import React from 'react';
import { IconChevronDown, IconChevronUp } from '@noths/polaris-client-ribbons-design-system';

import * as styles from './FooterLinksHeading.styles';

interface FooterLinksHeadingProps {
  isOpen?: boolean;
  title: string;
}

export const FooterLinksHeading = ({ isOpen, title }: FooterLinksHeadingProps) => {
  return (
    <h4
      css={styles.heading}
      style={{ '--spacing': isOpen ? '8px' : '36px' } as styles.CSSVarSpacing}
    >
      <span css={styles.title}>{title}</span>
      {isOpen ? <IconChevronUp css={styles.icon} /> : <IconChevronDown css={styles.icon} />}
    </h4>
  );
};
